import { isNil, omitBy } from 'lodash';
import { RegistrationFields } from 'modules/registration/constants';
import { Data } from 'modules/registration/types/data';

import { getCountryCodeById } from 'utils';

import { OdinAccountUpdate } from 'services/odinAccount';

function mapBERacerToOdinAccount(racer: Data.Backend.Racer): OdinAccountUpdate {
  const account: OdinAccountUpdate = {
    firstname: racer[RegistrationFields.firstname],
    lastname: racer[RegistrationFields.lastname],
    birthdate: mapValue(racer[RegistrationFields.birthday]),
    gender: mapValue(racer[RegistrationFields.gender]),
    country: getCountryCodeById(racer[RegistrationFields.country_id]),
    nationality: getCountryCodeById(racer[RegistrationFields.nationality_id]),
    street: mapValue(racer[RegistrationFields.address]),
    city: mapValue(racer[RegistrationFields.city]),
    postCode: mapValue(racer[RegistrationFields.post_code]),
  };

  return omitBy(account, isNil) as OdinAccountUpdate;
}

function mapValue(value: string | number | nil): string | undefined {
  if (isNil(value)) {
    return undefined;
  }

  return String(value);
}

export { mapBERacerToOdinAccount };
